<div class="w-auto h-auto relative mt-4">
   <button (click)="initializeGoogleSignIn()" class="btn w-full">
     <span>
       <svg-icon src="@assets/images/google-icon.svg" class="block w-[18px]"></svg-icon>
     </span>
     <span i18n>Sign in with Google</span>
   </button>
 </div>
 